/*
 * @Author: your name
 * @Date: 2020-06-18 15:06:22
 * @LastEditTime: 2020-06-22 20:59:08
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \leXiangH5线下落地页\src\config.js
 */

const isDev = process.env.NODE_ENV === 'development' ? true : false;

export const domain = isDev ? 'localhost:8081' : 'h5.yzhshop.cn';
export const baseURL = isDev ? 'https://dev-api.yzhshop.cn/' : "https://api.yzhshop.cn/";
export const staticUrl = 'https://static-wxcommunity.penguinvip.com';
export const microDownloadUrl = "https://a.app.qq.com/o/simple.jsp?pkgname=com.yunzhihui.lexiang";